import { executeApiCall } from 'services/api';
import { getMutations } from 'entities/hooks/mutation';

import { SuccessData } from 'types/api';
import { ProjectTag } from '../types';

type TagMutationParams = Pick<ProjectTag, 'name' | 'color' | 'id' | 'team'>;

export const teamTagsMutations = getMutations({
  toggleTag: {
    action: async ({ id, disabled }: { id: string; disabled: boolean }): Promise<SuccessData> => {
      return executeApiCall({
        path: `/teams/project-tags/status`,
        payload: {
          id,
          disabled,
        },
      });
    },
  },

  createProjectTag: {
    action: async (payload: TagMutationParams): Promise<ProjectTag> => {
      return executeApiCall({
        path: `/teams/project-tags`,
        payload,
      });
    },
  },

  updateProjectTag: {
    action: async (payload: TagMutationParams): Promise<ProjectTag> => {
      return executeApiCall({
        path: `/teams/project-tags`,
        payload,
        method: 'put',
      });
    },
  },
});
